(function () {
  'use strict';
  var root = document.getElementById('spPopup');
  if (!root || root.dataset.proofInitialized) return;
  root.dataset.proofInitialized = 'true';
  var desktop = window.matchMedia('(min-width:769px)');
  var close = document.getElementById('spClose');
  var main = document.getElementById('spMain');
  var age = document.getElementById('spTime');
  var flag = document.getElementById('spFlag');
  if (!close || !main || !age || !flag) return;
  var endpoint;
  try {
    endpoint = new URL(root.dataset.proofFeed);
    if (endpoint.protocol !== 'https:' && !['localhost', '127.0.0.1'].includes(endpoint.hostname)) return;
    if (endpoint.pathname !== '/v1/activity' || endpoint.search || endpoint.username || endpoint.password) return;
  } catch (_) { return; }
  var plans = ['Core', 'Plus', 'Pro'];
  var FIRST_DELAY = 3000, HOLD = 5000, GAP = 5000, MAX_SHOW = 15;
  var SNAPSHOT_MAX_AGE = 75 * 60;
  var regions = { AF: 'Africa', AS: 'Asia', EU: 'Europe', EU27: 'the EU', NA: 'North America', OC: 'Oceania', SA: 'South America' };
  var names;
  try { names = new Intl.DisplayNames(['en'], { type: 'region', fallback: 'none' }); } catch (_) { return; }
  var timer, hideTimer, ageTimer, expiryTimer, controller, queue = [], expires = 0, generated = 0, currentItem = null, loading = false, paused = false, stopped = false;
  var seen = [], shown = 0;
  function dismissed() { return /(?:^|;\s*)sp_dismissed=/.test(document.cookie); }
  function keys(value, expected) {
    return value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === expected.length && expected.every(function (k) { return Object.prototype.hasOwnProperty.call(value, k); });
  }
  function valid(data) {
    var now = Math.floor(Date.now() / 1000), ids = new Set();
    if (!keys(data, ['version', 'generated_at', 'expires_at', 'items']) || data.version !== 1 || !Number.isInteger(data.generated_at) ||
        data.generated_at > now + 30 || data.generated_at < now - SNAPSHOT_MAX_AGE || !Number.isInteger(data.expires_at) || data.expires_at <= now ||
        data.expires_at <= data.generated_at || data.expires_at > data.generated_at + SNAPSHOT_MAX_AGE || !Array.isArray(data.items) || data.items.length > 15) return false;
    return data.items.every(function (x) {
      var hasMinutes = Object.prototype.hasOwnProperty.call(x, 'age_minutes');
      if (!keys(x, ['id', 'event', 'plan', 'country_code', 'region_code', 'age'].concat(hasMinutes ? ['age_minutes'] : [])) ||
          !/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(x.id) || ids.has(x.id) ||
          !['trial_started', 'plan_started'].includes(x.event) || !plans.includes(x.plan) || (x.event === 'trial_started' && x.plan !== 'Core') ||
          !['past_day', 'past_three_days'].includes(x.age) || (x.country_code !== null && x.region_code !== null) ||
          (hasMinutes && (!Number.isInteger(x.age_minutes) || x.age_minutes < 0 || x.age_minutes > 4320 || x.age_minutes % 5 !== 0))) return false;
      if (x.country_code !== null && (!/^[A-Z]{2}$/.test(x.country_code) || ['ZZ', 'EU', 'UN'].includes(x.country_code) || !names.of(x.country_code))) return false;
      if (x.region_code !== null && !Object.prototype.hasOwnProperty.call(regions, x.region_code)) return false;
      ids.add(x.id); return true;
    });
  }
  function hide() { clearInterval(ageTimer); clearTimeout(expiryTimer); root.classList.remove('visible'); root.setAttribute('aria-hidden', 'true'); close.tabIndex = -1; }
  function armHide() {
    clearTimeout(hideTimer);
    if (root.contains(document.activeElement) || root.matches(':hover')) return;
    hideTimer = setTimeout(function () { hide(); schedule(GAP); }, HOLD);
  }
  function allowed() { return !stopped && !paused && !document.hidden && desktop.matches && !dismissed() && shown < MAX_SHOW; }
  function schedule(delay) { clearTimeout(timer); if (allowed()) timer = setTimeout(show, delay); }
  function remember(id) {
    seen.push(id); shown++;
  }
  function span(className, text) { var node = document.createElement('span'); node.className = className; node.textContent = text; return node; }
  function itemExpires(item) {
    return Number.isInteger(item.age_minutes) ? Math.min(expires, generated + (1440 - item.age_minutes - 5) * 60) : expires;
  }
  function updateAge() {
    if (!currentItem) return;
    if (Math.floor(Date.now() / 1000) >= itemExpires(currentItem)) { hide(); return; }
    if (!Number.isInteger(currentItem.age_minutes)) { age.textContent = 'Within the last 24 hours'; return; }
    var minutes = Math.floor((currentItem.age_minutes + Math.max(0, Math.floor(Date.now() / 1000) - generated) / 60) / 5) * 5;
    if (minutes >= 1440) { hide(); return; }
    var hours = Math.floor(minutes / 60);
    age.textContent = minutes < 60 ? 'About ' + minutes + ' mins ago' : 'About ' + hours + (hours === 1 ? ' hour ago' : ' hours ago');
  }
  function paint(item) {
    main.replaceChildren(document.createTextNode('A trader'));
    var location = item.country_code ? names.of(item.country_code) : regions[item.region_code];
    if (location) { main.appendChild(document.createTextNode(' from ')); main.appendChild(span('sp-country', location)); }
    main.appendChild(document.createTextNode(' started '));
    main.appendChild(span('sp-plan', item.event === 'trial_started' ? 'a 7-day Core trial for US$7' : 'the ' + item.plan + ' plan'));
    flag.textContent = item.country_code ? String.fromCodePoint.apply(String, Array.from(item.country_code).map(function (x) { return 127397 + x.charCodeAt(0); })) : item.region_code === 'EU27' ? '🇪🇺' : '🌍';
    currentItem = item; updateAge(); clearInterval(ageTimer); ageTimer = setInterval(updateAge, 30000);
  }
  async function load() {
    if (loading || !allowed()) return false;
    loading = true; controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 5000);
    try {
      var response = await fetch(endpoint.href, { credentials: 'omit', referrerPolicy: 'no-referrer', mode: 'cors', signal: controller.signal, cache: 'no-store' });
      if (!response.ok) throw new Error('unavailable');
      var reader = response.body.getReader(), chunks = [], size = 0;
      for (;;) {
        var part = await reader.read(); if (part.done) break;
        size += part.value.byteLength;
        if (size > 32768) { await reader.cancel(); throw new Error('oversize'); }
        chunks.push(part.value);
      }
      var bytes = new Uint8Array(size), offset = 0;
      chunks.forEach(function (chunk) { bytes.set(chunk, offset); offset += chunk.byteLength; });
      var data = JSON.parse(new TextDecoder().decode(bytes));
      if (!valid(data) || !allowed()) throw new Error('invalid');
      expires = data.expires_at; generated = data.generated_at;
      queue = data.items.filter(function (x) { return x.age === 'past_day' && itemExpires(x) > Math.floor(Date.now() / 1000) && !seen.includes(x.id); });
      return queue.length > 0;
    } catch (_) { queue = []; expires = 0; hide(); return false; }
    finally { clearTimeout(timeout); loading = false; }
  }
  async function show() {
    if (!allowed()) return;
    queue = queue.filter(function (x) { return itemExpires(x) > Math.floor(Date.now() / 1000); });
    if (Math.floor(Date.now() / 1000) >= expires || !queue.length) { if (!await load()) return; }
    if (!allowed() || !queue.length || Math.floor(Date.now() / 1000) >= expires) return;
    var item = queue.shift(); paint(item); remember(item.id);
    root.setAttribute('aria-hidden', 'false'); close.tabIndex = 0; root.classList.add('visible');
    expiryTimer = setTimeout(function () { hide(); schedule(GAP); }, Math.max(0, itemExpires(item) * 1000 - Date.now()));
    armHide();
  }
  close.addEventListener('click', function () {
    stopped = true; clearTimeout(timer); clearTimeout(hideTimer); if (controller) controller.abort(); queue = []; hide();
    document.cookie = 'sp_dismissed=1;Max-Age=604800;Path=/;SameSite=Lax' + (location.protocol === 'https:' ? ';Secure' : '');
  });
  root.addEventListener('mouseenter', function () { clearTimeout(hideTimer); });
  root.addEventListener('mouseleave', function () { if (root.classList.contains('visible')) armHide(); });
  root.addEventListener('focusin', function () { clearTimeout(hideTimer); });
  root.addEventListener('focusout', function () { if (root.classList.contains('visible')) armHide(); });
  function suspend() { clearTimeout(timer); clearTimeout(hideTimer); if (controller) controller.abort(); hide(); }
  document.addEventListener('visibilitychange', function () { if (document.hidden) suspend(); else schedule(FIRST_DELAY); });
  desktop.addEventListener('change', function () { if (!desktop.matches) suspend(); else schedule(FIRST_DELAY); });
  window.addEventListener('pagehide', function () { paused = true; suspend(); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) { paused = false; schedule(FIRST_DELAY); } });
  if (allowed()) load().then(function (ok) { if (ok) schedule(Math.max(0, FIRST_DELAY - performance.now())); });
})();
